import { FC, useEffect, useState } from 'react';
import { ITableColumn } from 'constants/tables';
import Icon, { IconNames } from 'components/Icon';
import colors from 'constants/colors';
import classNames from 'classnames';

interface Props {
  onSave: ((columns: ITableColumn[]) => void) | undefined;
  onSaveColumnDefaults?: ((columns: ITableColumn[]) => void) | undefined;
  columns: ITableColumn[];
}

export const ColumnsToggle: FC<Props> = ({ onSave, onSaveColumnDefaults, columns }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState(columns);

  useEffect(() => {
    setOptions(columns);
  }, [columns]);

  const toggle = () => setIsOpen(prevIsOpen => !prevIsOpen);

  const updateColumns = () => {
    onSave && onSave(options);
    toggle();
  };

  const saveColumnDefaults = () => {
    onSaveColumnDefaults && onSaveColumnDefaults(options);
    toggle();
  };

  const updateOptions = (accessor: string) => {
    setOptions(prevOptions =>
      prevOptions.map(column =>
        column.accessor === accessor ? { ...column, visible: !column.visible } : column
      )
    );
  };

  return (
    <div>
      <button onClick={toggle} className="show-columns-button">
        <span className="oath-utility">Show / Hide Columns</span>
        <Icon
          name={isOpen ? IconNames.ChevronUp : IconNames.ChevronDown}
          className="chevron-svg-light"
          color={colors.inkBlue}
        />
      </button>
      <div className="CollapseContainer">
        <div className={classNames('collapse', { show: isOpen })}>
          <div className="card FilterOptionsCard">
            {options.map(column => (
              <div key={column.accessor} className="CheckboxContainer">
                <div className="form-check form-check-inline">
                  <label htmlFor={`checkbox-${column.accessor}`} className="form-check-label">
                    <input
                      id={`checkbox-${column.accessor}`}
                      type="checkbox"
                      value={column.accessor}
                      checked={column.visible}
                      onChange={() => updateOptions(column.accessor)}
                    />
                    <span className="form-check-sign"></span>
                  </label>
                </div>
                <span key={column.accessor}>{column.label}</span>
              </div>
            ))}
            <button type="button" onClick={updateColumns} className="btn-inkBlue btn btn-secondary">
              Save
            </button>
            {onSaveColumnDefaults && (
              <button
                type="button"
                onClick={saveColumnDefaults}
                className="btn-link-compact link-text"
              >
                Save as Default
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
